import { customerApiUrl } from "api-url";
import { env } from "env";

export const getLocalApiUrl = (path: string): string => {
  const useLocalReportsApi = env.REACT_APP_USE_LOCAL_REPORTS_API;

  if (useLocalReportsApi) {
    const url = new URL(path, "http://localhost:8500");
    return url.toString();
  }
  return customerApiUrl(path);
};

export default getLocalApiUrl;
